module.exports = __webpack_public_path__ + "img/reaction_like.9cd2137.svg";